import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, memo, useMemo } from 'react';
import { useChartData } from '../../context/ChartContext';
import { useActiveSpectrum } from '../../hooks/useActiveSpectrum';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import useSpectrum from '../../hooks/useSpectrum';
import { rangeStateInit } from '../../reducer/Reducer';
import Range from './Range';
import RangeIntegral from './RangeIntegral';
function RangesInner({ ranges, displayerKey, selectedTool, showMultiplicityTrees, showRangesIntegrals, relativeFormat, }) {
    return (_jsx("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: ranges?.values?.map((range) => (_jsxs(Fragment, { children: [_jsx(Range, { range: range, selectedTool: selectedTool, showMultiplicityTrees: showMultiplicityTrees, relativeFormat: relativeFormat }), showRangesIntegrals && _jsx(RangeIntegral, { range: range })] }, range.id))) }));
}
const MemoizedRanges = memo(RangesInner);
export default function Ranges() {
    const { displayerKey, view: { ranges: rangeState, spectra: { activeTab }, }, toolOptions: { selectedTool }, } = useChartData();
    const activeSpectrum = useActiveSpectrum();
    const { showMultiplicityTrees, showRangesIntegrals } = useMemo(() => activeSpectrum
        ? rangeState.find((r) => r.spectrumID === activeSpectrum.id) ||
            rangeStateInit
        : rangeStateInit, [activeSpectrum, rangeState]);
    const spectrum = useSpectrum();
    const rangesPreferences = usePanelPreferences('ranges', activeTab);
    if (!spectrum?.display?.isVisible) {
        return null;
    }
    return (_jsx(MemoizedRanges, { ranges: spectrum.ranges, showMultiplicityTrees,
        showRangesIntegrals,
        selectedTool,
        displayerKey,
        relativeFormat: rangesPreferences.relative.format }));
}
